import { isLogin } from './cookie'
import { toLogin } from './helper'

export function ensureLogin(value = true, isBreak = false) {
  return function(target: any, propertyKey: string) {
    const original = target[propertyKey]
    if (typeof original === 'function') {
      target[propertyKey] = function(...args: any) {
        if (!isLogin() && value) {
          toLogin()
          if (isBreak) {
            return
          }
        }
        const result = original.apply(this, args)
        return result
      }
    }
    return original
  }
}
